// Material
import { styled } from '@mui/material/styles'
import { Box, Typography, TypographyProps } from '@mui/material'
// Icons
import { ExclamationMarkIcon } from '$common/icons/exclamation-mark'

const StyledIcon = styled(ExclamationMarkIcon)(() => ({
  marginRight: '8px',
}))

interface StyledTypographyProps {
  exclamationMode?: boolean
}

const StyledTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'exclamationMode',
})(({ exclamationMode }: StyledTypographyProps) => ({
  marginRight: exclamationMode ? '6px' : '8px',
}))

export function Label({
  title,
  required,
  exclamationMode,
  typographyProps,
  inParentheses,
}: {
  title: string
  required?: boolean
  exclamationMode?: boolean
  typographyProps?: TypographyProps
  inParentheses?: string
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {exclamationMode && <StyledIcon />}
      <StyledTypography
        variant="subtitle1"
        color="neutral600"
        exclamationMode={exclamationMode}
        {...typographyProps}
      >
        {title}
        {inParentheses && (
          <Typography component="span" variant="inherit" color="neutral500">
            {` (${inParentheses})`}
          </Typography>
        )}
      </StyledTypography>

      {required && (
        <Typography color="error" variant="subtitle3" sx={{ margin: '0 4px' }}>
          *
        </Typography>
      )}
    </Box>
  )
}

Label.defaultProps = {
  required: false,
  exclamationMode: false,
}
